export default __webpack_public_path__ + "f8315080c82694e5b4b19cd5d7c1d953.png";